import { render, staticRenderFns } from "./WBPoster.vue?vue&type=template&id=1e174340&scoped=true&"
import script from "./WBPoster.vue?vue&type=script&lang=js&"
export * from "./WBPoster.vue?vue&type=script&lang=js&"
import style0 from "./WBPoster.vue?vue&type=style&index=0&id=1e174340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e174340",
  null
  
)

export default component.exports